import React from "react";
import { Link } from "react-router-dom";
import { useMicrositeContext } from "./MicrositeLayout";
import { Card, CardContent } from "../../components/ui/card";
import { MapPin, Phone, Calendar } from "lucide-react";

export default function MicrositeContact() {
  const { clinic, slug, basePath } = useMicrositeContext();
  const primary = clinic.primary_color || "#2563EB";
  return (
    <div data-testid="microsite-contact">
      <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-2" style={{ fontFamily: "Manrope" }}>Contact us</h1>
      <p className="text-slate-500 mb-8">We&apos;ll get back to you as soon as possible.</p>
      <Card className="border-slate-200">
        <CardContent className="p-6 sm:p-8 space-y-4">
          {clinic.address && (
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: `${primary}1A`, color: primary }}>
                <MapPin className="w-5 h-5" />
              </div>
              <div>
                <div className="text-xs uppercase tracking-wide font-semibold text-slate-400">Address</div>
                <div className="text-slate-800 mt-0.5">{clinic.address}</div>
              </div>
            </div>
          )}
          {clinic.phone && (
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: `${primary}1A`, color: primary }}>
                <Phone className="w-5 h-5" />
              </div>
              <div>
                <div className="text-xs uppercase tracking-wide font-semibold text-slate-400">Phone</div>
                <a href={`tel:${clinic.phone}`} className="text-slate-800 mt-0.5 hover:underline">{clinic.phone}</a>
              </div>
            </div>
          )}
          <div className="pt-4 border-t border-slate-100">
            <Link
              to={`${basePath}/book`}
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg text-white font-medium"
              style={{ backgroundColor: primary }}
            >
              <Calendar className="w-4 h-4" /> Or book an appointment online
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
